import type { CSSProperties } from 'react'
import type { IconBaseProps, IconType } from 'react-icons'

import {
  aboutIcon,
  aiIcon,
  blogIcon,
  businessIntelligenceIcon,
  calculationsIcon,
  careerIcon,
  caseStudiesIcon,
  changelogIcon,
  communityIcon,
  compareIcon,
  customerSupportIcon,
  customersIcon,
  dataInputIcon,
  dataModelingIcon,
  developersIcon,
  documentsIcon,
  embeddedAnalyticsIcon,
  exploTransitionIcon,
  financialServicesIcon,
  integrationsIcon,
  mediaAdvertisingIcon,
  omnivisionIcon,
  partnersIcon,
  retailIcon,
  saasIcon,
  securityIcon,
  spreadsheetsIcon,
  subscribeIcon,
  userGuidesIcon,
} from './nav-icon-assets'

export {
  AppsNavIcon,
  DatabricksNavIcon,
  DbtNavIcon,
  EventsNavIcon,
  HexNavIcon,
  LookerNavIcon,
  MetabaseNavIcon,
  PowerBINavIcon,
  SigmaNavIcon,
  SnowflakeNavIcon,
  TableauNavIcon,
  StrategyNavIcon,
  ThoughtSpotNavIcon,
} from './nav-icons'

const makeRasterNavIcon = (src: string, scale = 1): IconType => {
  const RasterNavIcon: IconType = ({
    className,
    size,
    style,
    title,
  }: IconBaseProps) => {
    const dimension = size ?? '100%'
    const imageStyle: CSSProperties = {
      display: 'block',
      height: dimension,
      objectFit: 'contain',
      transform: scale === 1 ? undefined : `scale(${scale})`,
      width: dimension,
      ...style,
    }

    return (
      <img
        aria-hidden={title ? undefined : true}
        alt={title ?? ''}
        className={className}
        src={src}
        style={imageStyle}
      />
    )
  }

  return RasterNavIcon
}

export const AboutNavIcon = makeRasterNavIcon(aboutIcon)
export const AiNavIcon = makeRasterNavIcon(aiIcon)
export const BlogNavIcon = makeRasterNavIcon(blogIcon)
export const BusinessIntelligenceNavIcon = makeRasterNavIcon(
  businessIntelligenceIcon,
)
export const CalculationsNavIcon = makeRasterNavIcon(calculationsIcon)
export const CareerNavIcon = makeRasterNavIcon(careerIcon)
export const CaseStudiesNavIcon = makeRasterNavIcon(caseStudiesIcon)
export const ChangelogNavIcon = makeRasterNavIcon(changelogIcon)
export const CommunityNavIcon = makeRasterNavIcon(communityIcon)
export const CompareNavIcon = makeRasterNavIcon(compareIcon)
export const CustomerSupportNavIcon = makeRasterNavIcon(customerSupportIcon)
export const CustomersNavIcon = makeRasterNavIcon(customersIcon)
export const DataInputNavIcon = makeRasterNavIcon(dataInputIcon)
export const DevelopersNavIcon = makeRasterNavIcon(developersIcon)
export const DataModelingNavIcon = makeRasterNavIcon(dataModelingIcon)
export const DocumentsNavIcon = makeRasterNavIcon(documentsIcon)
export const EmbeddedAnalyticsNavIcon = makeRasterNavIcon(embeddedAnalyticsIcon)
export const ExploTransitionNavIcon = makeRasterNavIcon(exploTransitionIcon)
export const FinancialServicesNavIcon = makeRasterNavIcon(financialServicesIcon)
export const IntegrationsNavIcon = makeRasterNavIcon(integrationsIcon)
export const MediaAdvertisingNavIcon = makeRasterNavIcon(mediaAdvertisingIcon)
export const OmnivisionNavIcon = makeRasterNavIcon(omnivisionIcon)
export const PartnersNavIcon = makeRasterNavIcon(partnersIcon)
export const RetailNavIcon = makeRasterNavIcon(retailIcon)
export const SaasNavIcon = makeRasterNavIcon(saasIcon)
export const SecurityNavIcon = makeRasterNavIcon(securityIcon)
export const SpreadsheetsNavIcon = makeRasterNavIcon(spreadsheetsIcon, 1.18)
export const SubscribeNavIcon = makeRasterNavIcon(subscribeIcon)
export const UserGuidesNavIcon = makeRasterNavIcon(userGuidesIcon)
